import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import React__default from 'react';
import { hooks } from '@bilibili-maoer/web-utils';
import { useDeviceType } from '../../utils/hooks.js';
import { EDeviceType } from './types.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var HeaderContext = /*#__PURE__*/React__default.createContext({
  startBtnConfig: undefined,
  isMobileView: false,
  loading: true,
  user: null
});

var HeaderProvider = function HeaderProvider(_ref) {
  var value = _ref.value,
      children = _ref.children;
  var deviceType = useDeviceType();
  var isMobileView = deviceType === EDeviceType.Mobile;
  return /*#__PURE__*/React__default.createElement(HeaderContext.Provider, {
    value: _objectSpread(_objectSpread({}, value), {}, {
      isMobileView: isMobileView
    })
  }, children);
};

var HeaderContextProvider = function HeaderContextProvider(_ref2) {
  var showGuestBox = _ref2.showGuestBox,
      startBtnConfig = _ref2.startBtnConfig,
      type = _ref2.type,
      children = _ref2.children;

  var _hooks$useUser = hooks.useUser(),
      _hooks$useUser2 = _slicedToArray(_hooks$useUser, 2),
      user = _hooks$useUser2[0],
      loading = _hooks$useUser2[1].loading;

  if (type) {
    return /*#__PURE__*/React__default.createElement(HeaderContext.Provider, {
      value: {
        showGuestBox: showGuestBox,
        startBtnConfig: startBtnConfig,
        isMobileView: type === EDeviceType.Mobile,
        loading: loading,
        user: user
      }
    }, children);
  }

  return /*#__PURE__*/React__default.createElement(HeaderProvider, {
    value: {
      showGuestBox: showGuestBox,
      startBtnConfig: startBtnConfig,
      loading: loading,
      user: user
    }
  }, children);
};
var useHeaderContext = function useHeaderContext() {
  return React__default.useContext(HeaderContext);
};

export { HeaderContextProvider, useHeaderContext };
